module.exports = __webpack_public_path__ + "static/media/Circle.c3b215c4.svg";